import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
// Migrated 1:1 from @nexato/nx-core-module (label/components/label-widget/label-widget.component.ts, #683)
import { EditSelectable, EditSelectInputComponent } from '../../edit-select-form-control/edit-select-form-control.component';
import { EditMultiSelectV2InputComponent } from '../../edit-multiSelect-v2-form-control/edit-multiSelect-v2-form-control.component';
import { CommandService } from '../../../services/command/command.service';
import { CommandInput, CommandTemplate } from '../../../entities/commandTemplate/commandTemplate';
import { HasLabels } from '../../../entities/issue/issue';
import { Label } from '../../../entities/label/label';
import { IssueWidget } from '../../../services/issue/issue-widget.interface';
import { WidgetCoordinatorService } from '../../../services/issue/widget-coordinator.service';
import { RefetchCoordinator } from '../../../services/refetch-coordinator/refetch-coordinator.service';

@Component({
  selector: 'nx-label-widget',
  templateUrl: './label-widget.component.html',
})
export class LabelWidgetComponent implements OnDestroy, OnInit, OnChanges, IssueWidget {

  @Input() hasLabels: HasLabels;
  @ViewChild('selectComponent') selectComponent: EditMultiSelectV2InputComponent;
  public placeholder = "Labels auswählen"

  public editMode: boolean = false;
  public isLoading: boolean = false;

  public commandTemplate: CommandTemplate;

  public activeLabels: Label[];

  public allLabels: Label[];

  options: EditSelectable[] = [];
  selectedControl = new FormControl<any[] | null>(null);
  form = new FormGroup({
    selected: this.selectedControl
  });

  private widgetId = `label-widget-${Math.random().toString(36).substr(2, 9)}`;
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);
  private refetchCoordinator = inject(RefetchCoordinator);
  private unregisterRefetch?: () => void;

  constructor(
    private commandService: CommandService,
    private coordinator: WidgetCoordinatorService
  ) {
  }


  ngOnInit(): void {
    // Register with RefetchCoordinator as detail view
    if (this.hasLabels?.getEntityId()) {
      this.unregisterRefetch = this.refetchCoordinator.register(
        this,
        this.hasLabels.getEntityType(),
        this.hasLabels.getEntityId()
      );
    }

    // Subscribe to cancel all requests
    this.coordinator.cancelAll$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(exceptId => {
        if (exceptId !== this.widgetId) {
          this.cancel();
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['hasLabels'] && this.hasLabels && this.hasLabels.getEntityId) {
      this.loadCommandTemplate();
    }
  }

  loadCommandTemplate() {
    const commandInput = new CommandInput();
    commandInput.name = "labelUpdateLabelReferenceCommand";
    commandInput.addParameter('referenceId', this.hasLabels.getEntityId());
    commandInput.addParameter('referenceType', this.hasLabels.getEntityType());

    this.commandService.getCommandByCommandInput(commandInput)
        .pipe(take(1))
        .subscribe(result => {
          this.allLabels = Label.createLabels(result?.data?.getCommandByCommandInput?.flow?.settings?.customFlowSettings?.allLabels);
          this.activeLabels = Label.createLabels(result?.data?.getCommandByCommandInput?.flow?.settings?.customFlowSettings?.activeLabels);
          this.options = this.allLabels;
          // this.activeLabels = [];
          // this.activeLabels.push(this.allLabels[0]);
          this.selectedControl.patchValue(this.activeLabels);
          this.commandTemplate = result.data.getCommandByCommandInput;
          this.isLoading = false;
          this.cdr.detectChanges();
        });
  }

  ngOnDestroy(): void {
    this.unregisterRefetch?.();
  }

  edit() {
    this.coordinator.requestCancelAll(this.widgetId);
    this.editMode = true;

    // Open dropdown and focus filter after view is rendered
    setTimeout(() => {
      console.log('Opening dropdown and focusing filter');
      this.selectComponent?.openAndFocusFilter();
    }, 10);
  }

  save() {
    this.editMode = false;
    let selectedIds = this.selectedControl.value ? this.selectedControl.value.map((label: Label) => label.id) : undefined;
    let commandInput = new CommandInput();
    commandInput.name = this.commandTemplate.name;
    commandInput.addParameter('referenceId', this.hasLabels.getEntityId());
    commandInput.addParameter('referenceType', this.hasLabels.getEntityType());
    commandInput.addParameter('labelIds', selectedIds);
    this.isLoading = true;
    this.commandService.sendCommand(commandInput, (result) => {
      this.loadCommandTemplate();
      this.refetchCoordinator.emit({ entityType: this.hasLabels.getEntityType(), entityId: this.hasLabels.getEntityId() });
    });
  }

  cancel() {
    this.editMode = false;
  }

  setActiveState(commandTemplate: CommandTemplate) {
    // extract all statuses from the command template
    // let statuses = IssueStatus.createIssueStatuses(commandTemplate?.flow?.settings?.customFlowSettings?.statuses) || [];
    // this.options = statuses;
    // this.activeStatus = statuses.find(status => status.settings && status.settings.active === true);
  }

  setStateOptions(commandTemplate: CommandTemplate) {
  }

  onFilter = (filterValue: string) => {
    console.log('Remote filter triggered with value:', filterValue);
  };

  reload(): void {
    this.loadCommandTemplate();
  }
}
